import React, {useState} from 'react';
import {MenuItem} from '@material-ui/core';
import MarkAsPaidDialog from '../dialogs/MarkAsPaidDialog';
import * as LabelHelper from '../../../utils/LabelHelper';
import {PaymentActionType} from './PaymentActionHelper';

const PaymentMarkAsPaidAction = React.forwardRef(({ payment, setMenuAnchor, label }: PaymentActionType, ref: React.Ref<any>) => {
  const [markAsPaidDialog, setMarkAsPaidDialog] = useState(false);

  return (
    <>
      <MenuItem
        ref={ref}
        key={payment.id + 'markAsPaid'}
        onClick={() => {
          setMenuAnchor(null);
          setMarkAsPaidDialog(true);
        }}
      >
        {label}
      </MenuItem>
      <MarkAsPaidDialog
        payment={payment}
        open={markAsPaidDialog}
        onCancel={() => setMarkAsPaidDialog(false)}
        customer={LabelHelper.getDebtorLabel(payment.debitor) || payment.debitor.emailAddress}
      />
    </>
  );
});

export default PaymentMarkAsPaidAction;
